import moment from 'moment';
export const log = {
    info: (caller, message) => {
        console.log(`⚡️[${caller}][${getDateString()}] INFO: ${message}`);
    },
    warn: (caller, message) => {
        console.log(`⚡️[${caller}][${getDateString()}] WARN: ${message}`);
    },
    error: (caller, message) => {
        console.error(`⚡️[${caller}][${getDateString()}] ERROR: ${message}`);
    }
};
const getDateString = () => {
    return moment().format('YYYY-MM-DD HH:mm:ss A');
};
//# sourceMappingURL=log.js.map